import type { components } from '@pba/types-openapi-client';
import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type UsersParams = {
  limit?: number;
  program_ids: string[];
  scope: 'programs';
  search?: string;
};

export const getProgramUsersAutocomplete = async ({ config }: ConfigRequest<UsersParams>) =>
  apiClient.get<Array<components['schemas']['UserList']>, ApiClientResponse<Array<components['schemas']['UserList']>>>(
    routes.program.autoComplete,
    config,
  );
